__turbopack_context__.v({
  "captchaBackdrop": "fastly-challenge-module-scss-module__Sa193W__captchaBackdrop",
  "dialog": "fastly-challenge-module-scss-module__Sa193W__dialog",
  "overlay": "fastly-challenge-module-scss-module__Sa193W__overlay",
});
